import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { MANAGE_TABS, ManagePage } from "@/features/helpdesk/manage-page";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	tab: z.enum(MANAGE_TABS).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/helpdesk/zarzadzanie")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.helpdesk.zarzadzanie",
			location.pathname,
		);
	},
	validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
	component: ManageRoute,
});

function ManageRoute() {
	const { tab } = Route.useSearch();
	const navigate = useNavigate({ from: "/helpdesk/zarzadzanie" });
	return (
		<ManagePage
			tab={tab ?? "parowanie"}
			onTabChange={(next) =>
				navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true })
			}
		/>
	);
}
